import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@mui/material";
// import useAuth from '../../hooks/useAuth';

// Components
import OsanoLink from "../OsanoLink/OsanoLink";

const LoginButton = ({ version }) => {
  const { loginWithRedirect } = useAuth0();
  // const { loginWithRedirect } = useAuth();

  if (version === 'landing') {
    return (
      <>
        <Button
          sx={{
            display: 'block',
            width: '100%',
            padding: 0,
            borderRadius: 100,
            backgroundColor: '#059BD6',
            fontSize: 16,
            fontWeight: 400,
            letterSpacing: .4,
            height: 36,
            color: '#fff',
            textTransform: 'none',
            border: '1px solid #0d6efd',
            "&:hover": {
              backgroundColor: "#fff",
              color: '#059BD6',
              border: '1px solid #0d6efd'
            },
          }}
          onClick={() => loginWithRedirect()}
        >
          Sign In / Register to SE 2050 Database
        </Button>
        <OsanoLink />
      </>
    );
  } else {
    return (
      <Button
        variant="contained"
        sx={{ marginLeft: "auto" }}
        onClick={() => loginWithRedirect()}
      >
        Log In
      </Button>
    );
  }
};

export default LoginButton;
